export const GANTT_MONTH_WIDTH = 79;
export const GANTT_SMALL_MONTH_WIDTH = 69;
export const GANTT_FIRST_COLUMN_WIDTH = 235;
export const GANTT_ONE_SIDE_PADDING = 16;
export const GANTT_CHART_MONTH_QUANTITY = 12;
